import styled from "styled-components";
import { Col, Row } from "react-flexbox-grid";
import { Link } from "react-router-dom";

import { fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const StyledTitle = styled.h2`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 50px;
  min-height: 65px;
  position: relative;
  ${breakpoints.smUp} {
    padding-right: 80px;
  }
  ${breakpoints.smDown} {
    font-size: 25px;
    padding-right: 60px;
  }
  > [aria-label] {
    ${breakpoints.smDown} {
      position: absolute;
      right: 0;
      top: 2px;
    }
  }
`;

export const ResultsFound = styled.h3`
  font-family: ${fonts.fontInterstateUltraBlack};
  font-size: 25px;
  min-height: 65px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-transform: uppercase;
  position: relative;
  ${breakpoints.smUp} {
    padding-right: 80px;
  }
  ${breakpoints.smDown} {
    display: none;
  }
  > [aria-label] {
    ${breakpoints.smDown} {
      position: absolute;
      right: 0;
      top: 2px;
    }
  }
`;

export const RowComponent = styled(Row)`
  ${breakpoints.smUp} {
    padding-right: 15px;
  }
`;

export const ColComponent = styled(Col)`
  display: flex;
  justify-content: center;
`;

export const NoResultsContainer = styled.div``;

export const NoResultsMessage = styled.p`
  width: 100%;
  font-size: 16px;
  margin-bottom: 0px;
`;

export const StyledLink = styled(Link)`
  font-size: 16px;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  &:hover {
    text-decoration: underline;
  }
`;
